<template>
  <v-dialog v-model="dialog" transition>
    <v-card class="vcard">
      <v-flex>
        <v-chip class="ma-2" outlined>
          <v-icon left>
            mdi-calendar
          </v-icon>
          日期</v-chip
        >
        <span>{{ item.news_start_date }}</span>
      </v-flex>
      <v-flex>
        <v-chip class="ma-2" color="accent-4" outlined>
          <v-icon left>
            mdi-pencil
          </v-icon>
          標題
        </v-chip>
        <span class="newstitle">{{ item.news_title }}</span>
      </v-flex>
      <v-flex>
        <v-chip class="ma-2" outlined>
          <v-icon left>
            mdi-message-text-outline
          </v-icon>
          內容
        </v-chip>
      </v-flex>
      <v-flex mb-5>
        <div class="fck" v-html="item.news_content"></div>
      </v-flex>
      <v-flex xs1 md1 lg1 v-if="!!item.news_file1">
        <v-chip class="ma-2" outlined>
          <v-icon left>
            mdi-files
          </v-icon>
          附檔一
        </v-chip>
      </v-flex>
      <v-flex xs11 md11 lg11>
        <span>{{ item.news_file1 }}</span>
      </v-flex>
      <v-flex xs1 md1 lg1 v-if="!!item.news_file2">
        <v-chip class="ma-2 newstitle" outlined>
          <v-icon left>
            mdi-files
          </v-icon>
          附檔二
        </v-chip>
      </v-flex>
      <v-flex xs11 md11 lg11>
        <span>{{ item.news_file2 }}</span>
      </v-flex>

      <v-flex xs1 md1 lg1 v-if="!!item.news_file3">
        <v-chip class="ma-2" outlined>
          <v-icon left>
            mdi-files
          </v-icon>
          附檔三</v-chip
        >
      </v-flex>
      <v-flex xs11 md11 lg11>
        <span>{{ item.news_file3 }}</span>
      </v-flex>
      <v-flex xs1 md1 lg1 v-if="!!item.news_link">
        <v-chip class="ma-2" outlined>
          <v-icon left>
            mdi-files
          </v-icon>
          相關連結
        </v-chip>
      </v-flex>
      <v-flex xs11 md11 lg11>
        <div @click="navLink(item.news_link)">{{ item.news_link }}</div>
      </v-flex>
      <!-- <v-overlay absolute :value="loading">
        <v-progress-circular size="64" indeterminate />
      </v-overlay> -->
      <v-card-actions>
        <v-col class="text-center">
          <v-btn @click="dialog = false" class="btn_close">
            <v-icon large left>
              mdi-close-circle-outline
            </v-icon>
            關閉
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import api from "../utils/apis/DepApi.js";

export default {
  props: { value: Boolean, item: Object },
  data: () => ({
    dense: false,
    loading: false,
  }),
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style>
.vcard {
  padding: 30px;
  /* background: #8e5ba6 !important; */
  box-shadow: none !important;
  /* max-width: 610px !important; */
  /* background-color:#FFAC55; */
  /* border-width:3px;border-style:dashed;border-color:#FFAC55; */
}

.v-chip {
  padding: 8px 20px;
  margin-right: 15px;
}
.newstitle {
  font-weight: bold;
  color: #d7433a;
}
.theme--light.v-btn {
  padding: 40px;
}
/* vdiolog關閉按鈕 */
.theme--light.v-btn.v-btn--has-bg {
  background-color: #f19e99;
  color: #fff;
  border: 1px solid #939687;
  box-shadow: none !important;
}
/* vdiolog關閉按鈕 */
.v-btn__content {
  padding: inherit;
  font-size: 1rem !important;
}

.v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  padding: 8px 20px !important;
  margin-bottom: 4px !important;
  display: flex !important;
  align-items: center !important;
}

.v-text-field .v-input__control .v-input__slot .v-input__append-inner {
  margin-top: 5px !important;
}

.v-text-field .v-input__control .v-input__slot label {
  margin-top: -5px !important;
}

.v-text-field .v-input__control .v-input__slot label.v-label--active {
  margin: 0 !important;
}

.v-text-field__details {
  margin: 2px !important;
}
.newscontent {
  padding: 10px 60px;
  overflow: hidden;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  text-overflow: ellipsis;
}
.newscontent p {
  padding: 10px 0;
  line-height: 2rem;
  font-size: 16px;
  color: #222;
}
.newscontent:before {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  content: "\f086";
  font-size: 16px;
  color: #d7433a;
  margin-right: 5px;
}

/* uptime_title 顏色 */
.theme--light.v-chip {
  border-color: #fff;
  border-bottom: 1px solid #ccc;
  color: #758f1f;
  font-size: 1.25rem;
  margin-right: 1rem;
}
.link {
  margin: 10px 50px;
}
.v-input {
  flex-wrap: wrap;
  /* border-bottom:1px solid #ccc; */
}
.newsuptime i {
  padding: 10px 10px 0 20px;
  /* color: #f19e99; */
}
</style>
